<template>
  <v-col v-if="podeVisualizar" cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto d-flex flex-column" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text class="text-h6 font-weight-black flex-grow-1"> Unidades Escolares </v-card-text>

      <v-card-text class="text-h4 font-weight-black text-no-wrap d-flex align-center pt-0 pb-6">
        {{ qtd ?? 0 }}
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";

const ROLES_COM_ACESSO = ["super-admin", "admin", "coordenador-semed"];

export default {
  name: "UnidadesCard",
  mounted() {
    if (this.podeVisualizar) this.getQtd();
  },
  data() {
    return {
      loading: true,
      qtd: 0,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeVisualizar() {
      return (this.user?.roles ?? []).some((role) => ROLES_COM_ACESSO.includes(role.name));
    },
  },
  watch: {
    podeVisualizar(podeVisualizar) {
      if (podeVisualizar && this.loading) this.getQtd();
    },
  },
  methods: {
    async getQtd() {
      this.qtd = await this.$services.franquiasService.qtd();
      this.loading = false;
    },
  },
};
</script>
